module.exports = __webpack_public_path__ + "static/media/termsAndAgreements.96e145dc.svg";